<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <!-- 弹窗, 新增 / 修改 -->
    <rewardUpdate v-show="addOrUpdateVisible" @refreshDataList="refreshDataList" ref="rewardUpdate"></rewardUpdate>
  </div>
</template>

<script>
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import rewardUpdate from '../rebate/rewardUpdate.vue'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'
    let  activeStatus = {"-1": "活动状态", "DRAFT": "待执行", "PENDING": "执行中", "DISABLE": "禁用", "END": "已到期","WILL":"未开始"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            rewardUpdate
        },
        methods: {
            checkbox(row){
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.addOrUpdateHandle(row,false);
                } else if (clickName == "details") {
                    this.addOrUpdateHandle(row,true);
                }
            },
            // 新增 / 修改
            addOrUpdateHandle(row,type) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.rewardUpdate.dataForm.activeType = 0;
                    this.$refs.rewardUpdate.detail = type;
                    this.$refs.rewardUpdate.init(row)
                })
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.query') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                }else if(window.$t('txmis.bt.add') == clickName){
                    this.addOrUpdateHandle(false,false);
                }else if(window.$t('txmis.bt.down') == clickName){
                    download.exportExcel(URL.rebateActivity.downloadActivity,data,window.$t('txmis.accountReward.downloadActivity'));
                }
            },
            refreshDataList(){
                this.$refs.childTable.defaultGetData(this.queryData);
            },
            dataChanage(url,option,suc,fail){
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        {title: window.$t('txmis.common.startTime'), field: 'beginDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('txmis.common.endTime'), field: 'endDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('txmis.accountReward.activeStatus'), field: 'activeStatus', type: 2, optionList: activeStatus},
                        {title: window.$t('txmis.accountReward.activeName'), field: 'activeName'},
                        {title: window.$t('txmis.accountReward.activeType'), field: 'activeType', data: 0, hidden: true},
                        {click: window.$t('txmis.bt.query')},
                        {click: window.$t('txmis.bt.add')},
                        {click: window.$t('txmis.bt.down')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.rebateActivity.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('txmis.accountReward.proposalNo'), field: 'proposalNo',h5Click: "details"},
                        {title: window.$t('txmis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('txmis.accountReward.activeName'), field: 'activeName'},
                        {
                            title: window.$t('txmis.accountReward.activeStatus'), field: 'activeStatus', render: (data, full) => {
                                return activeStatus[data] || "";
                            }
                        },
                        {title: window.$t('txmis.accountReward.beginDate'), field: 'beginDate'},
                        {title: window.$t('txmis.accountReward.endDate'), field: 'endDate'},
                        {title: window.$t('txmis.accountReward.expDay'), field: 'expDay'},
                        {title: window.$t('txmis.accountReward.proposalUser'), field: 'proposalUser'},
                        {title: window.$t('txmis.accountReward.proposalDate'), field: 'proposalDate'},
                        {title: window.$t('txmis.accountReward.approvalUser'), field: 'approvalUser'},
                        {title: window.$t('txmis.accountReward.approvalDate'), field: 'approvalDate'},
                        {
                            field: window.$t('txmis.bt.edit'),
                            title: window.$t('txmis.bt.operation'),
                            size: "mini",
                            click: "update",
                            type: "primary",
                            icon: "el-icon-update"
                        }
                    ]
                }
            }
        }
    }
</script>
